import React, { useEffect, useState } from "react";
import ModalCenter from "../../../../components/common/Modal/ModalCenter";
import Button from "../../../../components/common/buttons/Button";
import InputTextSimple from "../../../../components/common/InputText/InputTextSimple";
import CheckBoxWithOutLabel from "../../../../components/common/checkbox/CheckboxWithoutLabel";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import ButtonOutlineFluid from "../../../../components/common/buttons/ButtonOutlineFluid";
import { useDispatch, useSelector } from "react-redux";
import SelectOption from "../../../../components/common/select/SelectOption";
import useAuth from "../../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import { toast } from "react-toastify";
import { ROUTES } from "../../../../constants/Routes";
import InputNumbersSimple from "../../../../components/common/InputText/InputNumbersSimple";
import { ProposalItemActions } from "../../../../store/Slice/ProposalItemSlice";

const ItemCreateModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");

  const zonesArr = useSelector((state) => state.proposalItems.zones);

  const { getAuth, clearAuth } = useAuth();

  const dispatch = useDispatch();

  useEffect(() => {
    const mappedZones = [];
    zonesArr.map((zone, index) => {
      mappedZones.push({
        value: zone?.id,
        label: zone?.nev,
      });
    });
    setZones(mappedZones);
  }, [zonesArr]);

  const selectedZoneChangeHandler = (selectedValue) => {
    setSelectedZone(selectedValue);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const navigate = useNavigate();
  //Item Name
  const [targyNeve, setTargyNeve] = useState("");
  const [targyNeveError, setTargyNeveError] = useState("");
  //zone
  const [zoneError, setZoneError] = useState("");
  //Electricians
  const [villanyszerelo, setVillanyszerelo] = useState(false);
  const [villanyszereloError, setVillanyszereloError] = useState("");
  //Kitchen Fitter
  const [konyhaszerelo, setKonyhaszerelo] = useState(false);
  const [konyhaszereloError, setKonyhaszereloError] = useState(false);
  //Dübel Arbeiten
  const [dubelArbeiten, setDubelArbeiten] = useState(false);
  const [dubelArbeitenError, setDubelArbeitenError] = useState(false);
  //Volumen
  const [volume, setVolume] = useState(0);
  const [volumeError, setVolumeError] = useState("");
  //Csomagolási idő /fő
  const [csomagolasiIdo, setCsomagolasiIdo] = useState(0);
  const [csomagolasiIdoError, setCsomagolasiIdoError] = useState("");
  //Buborékcsomagolási idő /fő
  const [buborekcsomagolasiIdo, setBuborekcsomagolasiIdo] = useState(0);
  const [buborekcsomagolasiIdoError, setBuborekcsomagolasiIdoError] = useState("");

  //Kicsomagolási idő /fő
  const [kicsomagolasiIdo, setKicsomagolasiIdo] = useState(0);
  const [kicsomagolasiIdoError, setKicsomagolasiIdoError] = useState("");

  //Szétszerelési idő /fő
  const [szetszerelesiIdo, setSzetszerelesiIdo] = useState(0);
  const [szetszerelesiIdoError, setSzetszerelesiIdoError] = useState("");

  //Összeszerelési idő /fő
  const [osszeszerelesiIdo, setOsszeszerelesiIdo] = useState(0);
  const [osszeszerelesiIdoError, setOsszeszerelesiIdoError] = useState("");

  const reset = () => {
    setTargyNeve("");
    setVillanyszerelo(false);
    setKonyhaszerelo(false);
    setDubelArbeiten(false);
    setVolume(0);
    setCsomagolasiIdo(0);
    setBuborekcsomagolasiIdo(0);
    setKicsomagolasiIdo(0);
    setSzetszerelesiIdo(0);
    setOsszeszerelesiIdo(0);
    setSelectedZone("");

    setTargyNeveError("");
    setZoneError("");
    setVillanyszereloError("");
    setKonyhaszereloError("");
    setDubelArbeitenError("");
    setVolumeError("");
    setCsomagolasiIdoError("");
    setBuborekcsomagolasiIdoError("");
    setKicsomagolasiIdoError("");
    setSzetszerelesiIdoError("");
    setOsszeszerelesiIdoError("");
  };

  const resetErrors = () => {
    setTargyNeveError("");
    setVillanyszereloError("");
    setKonyhaszereloError("");
    setDubelArbeitenError("");
    setVolumeError("");
    setCsomagolasiIdoError("");
    setBuborekcsomagolasiIdoError("");
    setKicsomagolasiIdoError("");
    setSzetszerelesiIdoError("");
    setOsszeszerelesiIdoError("");
    setZoneError("");
  };
  const saveItem = () => {
    resetErrors();

    const zoneId = selectedZone;

    HttpHelper.PostRequest({
      route: API_ROUTES.PR_ITEM_CREATE,
      token: getAuth()?.bearerToken,
      parameters: {
        targyNeve,
        villanyszerelo,
        konyhaszerelo,
        dubelArbeiten,
        volume,
        csomagolasiIdo,
        buborekcsomagolasiIdo,
        kicsomagolasiIdo,
        szetszerelesiIdo,
        osszeszerelesiIdo,
        zoneId,
      },
    })
      .then((res) => {
        if (res.status == 200) {
          console.log(res?.data);
          dispatch(ProposalItemActions.pushNewItem(res?.data?.zoneItem));
          reset();
          closeModal();
          toast.success("Zone Item successfully updated !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status == 422) {
          const messages = res.message;
          for (const key in messages) {
            if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
              const errorMessage = messages[key][0];
              if (key === "targyNeve") {
                setTargyNeveError(errorMessage);
              } else if (key === "zoneId") {
                setZoneError(errorMessage);
              } else if (key === "villanyszerelo") {
                setVillanyszereloError(errorMessage);
              } else if (key === "konyhaszerelo") {
                setKonyhaszereloError(errorMessage);
              } else if (key === "dubelArbeiten") {
                setDubelArbeiten(errorMessage);
              } else if (key === "volume") {
                setVolumeError(errorMessage);
              } else if (key === "csomagolasiIdo") {
                setCsomagolasiIdoError(errorMessage);
              } else if (key === "bubbleWrapping") {
                setBuborekcsomagolasiIdoError(errorMessage);
              } else if (key === "kicsomagolasiIdo") {
                setKicsomagolasiIdoError(errorMessage);
              } else if (key === "szetszerelesiIdo") {
                setSzetszerelesiIdoError(errorMessage);
              } else if (key === "osszeszerelesiIdo") {
                setOsszeszerelesiIdo(errorMessage);
              }
            }
          }
        } else if (res.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unknown error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <>
      <ButtonOutlineFluid onClick={openModal} label={`Új tétel hozzáadása`} />
      {/* <button className="w-6 h-6" onClick={openModal}>
        +
      </button> */}

      <ModalCenter isOpen={isOpen} closeModal={closeModal} header="Új tétel hozzáadása">
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">Tárgy neve</label>
          <InputTextSimple
            placeholder={``}
            variant="light"
            value={targyNeve}
            error={targyNeveError}
            onChange={(e) => setTargyNeve(e.target.value)}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] text-[#323232] font-lato font-normal leading-normal">Zónák</label>
          <SelectOption
            placeholder={`Válasszon egy zónát`}
            options={zones}
            value={selectedZone}
            error={zoneError}
            onChange={selectedZoneChangeHandler}
            variant="light"
          />
        </div>

        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">Villanyszerelő</label>
          <CheckBoxWithOutLabel
            value={villanyszerelo}
            checked={villanyszerelo}
            name={"villanyszerelo"}
            id={"villanyszerelo"}
            error={villanyszereloError}
            onClick={(e) => {
              setVillanyszerelo(!villanyszerelo);
            }}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem]   font-lato font-normal leading-normal">Konyhaszerelő</label>
          <CheckBoxWithOutLabel
            checked={konyhaszerelo}
            value={konyhaszerelo}
            id={`konyhaszerelo`}
            name={`konyhaszerelo`}
            error={konyhaszereloError}
            onClick={(e) => {
              setKonyhaszerelo(!konyhaszerelo);
            }}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Dübel Arbeiten</label>
          <CheckBoxWithOutLabel
            checked={dubelArbeiten}
            value={dubelArbeiten}
            id={`dubelArbeiten`}
            name={`dubelArbeiten`}
            error={dubelArbeitenError}
            onClick={(e) => {
              setDubelArbeiten(!dubelArbeiten);
            }}
          />
        </div>

        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Volumen (m3)</label>
          <InputNumbersSimple
            placeholder={``}
            variant="light"
            id={"volume"}
            name={"volume"}
            value={volume}
            error={volumeError}
            onChange={(e) => setVolume(e.target.value)}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Csomagolási idő /fő</label>
          <InputNumbersSimple
            placeholder={``}
            variant="light"
            id={"csomagolasiIdo"}
            name={"csomagolasiIdo"}
            value={csomagolasiIdo}
            error={csomagolasiIdoError}
            onChange={(e) => setCsomagolasiIdoError(e.target.value)}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
            Buborékcsomagolási idő /fő
          </label>
          <InputNumbersSimple
            placeholder={``}
            variant="light"
            id={"buborekcsomagolasiIdo"}
            name={"buborekcsomagolasiIdo"}
            value={buborekcsomagolasiIdo}
            error={buborekcsomagolasiIdoError}
            onChange={(e) => setBuborekcsomagolasiIdo(e.target.value)}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Kicsomagolási idő /fő</label>
          <InputNumbersSimple
            placeholder={``}
            variant="light"
            id={"kicsomagolasiIdo"}
            name={"kicsomagolasiIdo"}
            value={kicsomagolasiIdo}
            error={kicsomagolasiIdoError}
            onChange={(e) => setKicsomagolasiIdo(e.target.value)}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Szétszerelési idő /fő</label>
          <InputNumbersSimple
            placeholder={``}
            variant="light"
            id={"szetszerelesiIdo"}
            name={"szetszerelesiIdo"}
            value={szetszerelesiIdo}
            error={szetszerelesiIdoError}
            onChange={(e) => setSzetszerelesiIdo(e.target.value)}
          />
        </div>
        <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Összeszerelési idő /fő</label>
          <InputNumbersSimple
            placeholder={``}
            variant="light"
            id={"osszeszerelesiIdo"}
            name={"osszeszerelesiIdo"}
            value={osszeszerelesiIdo}
            error={osszeszerelesiIdoError}
            onChange={(e) => setOsszeszerelesiIdo(e.target.value)}
          />
        </div>

        <div className="mt-12 ps-[230px] gap-5 flex flex-row  text-center">
          <ButtonOutlineFluid label={`Mégsem`} onClick={closeModal} />
          <ButtonFluid label={`Mentés`} onClick={saveItem} />
        </div>
      </ModalCenter>
    </>
  );
};

export default ItemCreateModal;
